import { Injectable } from '@angular/core';
import { LoggerProvider, LoggerEvent } from '../logger/logger';
import { ScriptProvider } from '../script/script';
import { Platform } from 'ionic-angular';
import { APP_CONFIG } from '../../environment';

declare let window: any;
declare let ioGetBlackbox;
declare let FraudForcePlugin;
@Injectable()
export class IovationProvider {

  private iovationPromise = null;
  private fallback: boolean = false;
  private iovationLoaded = false;
  constructor(private scriptProvider: ScriptProvider,
              private platform: Platform) {
  }

  async loadIovation() {
    LoggerProvider.info(this, 'Load Iovation');
    await this.platform.ready();
    if (!this.iovationPromise)  {
      if (this.platform.is('cordova')) {
        this.iovationPromise = new Promise(async (resolve) => {
            if (FraudForcePlugin) {
              FraudForcePlugin.start(
                (result) => {
                  LoggerProvider.info(this, 'Succesfully loaded Iovation', result);
                  resolve(true);
                },
                async (err) => {
                  LoggerProvider.error(this, LoggerEvent.GeneralException, 'Iovation Plugin Failed to load', err);
                  this.fallback = true;
                  const result = await this.scriptProvider.loadScript(APP_CONFIG.iovationScript);
                  LoggerProvider.info(this, 'Fallback result: ' + result);
                  resolve(result);
                },
              );
            } else {
              LoggerProvider.error(this, LoggerEvent.GeneralException, 'Iovation Plugin is not initialized');
              this.fallback = true;
              const result = await this.scriptProvider.loadScript(APP_CONFIG.iovationScript);
              LoggerProvider.info(this, 'Fallback result: ' + result);
              resolve(result);
            }
          });
      } else {
        this.iovationPromise = this.scriptProvider.loadScript(APP_CONFIG.iovationScript);
      }
    }
    return this.iovationPromise;
  }

  async getIovationBlackbox(): Promise<any> {
    LoggerProvider.info(this, 'Get Iovation blackbox');
    await this.platform.ready();
    var iovationState = false;
    if(!this.iovationLoaded) {
      iovationState = await this.loadIovation();
    } else {
      iovationState = true;
    }
    if (this.platform.is('cordova') && !this.fallback) {
      return new Promise((resolve) => {
        if (iovationState) {
          FraudForcePlugin.blackbox(
            (blackbox: string) => {
              if( blackbox !== null && blackbox !== undefined) LoggerProvider.info(this, 'Succesfully got Iovation blackbox', blackbox);
              else LoggerProvider.error(this, LoggerEvent.GeneralException, 'Unable to get Iovation blackbox', "Iovation plugin returned empty box! https://github.com/iovation/deviceprint-SDK-iOS#important");
              resolve(blackbox);
            },
            (err) => {
              LoggerProvider.error(this, LoggerEvent.GeneralException, 'Unable to get Iovation blackbox', err);
              resolve(null);
            }
          );
        } else {
          LoggerProvider.warning(this, LoggerEvent.ProviderException, 'Iovation not available');
          resolve(null);
        }
      });
    }
    else {
      try {
        if (typeof ioGetBlackbox !== 'undefined' && ioGetBlackbox) {
          const blackbox = ioGetBlackbox().blackbox;
          LoggerProvider.debug(this, 'Succesfully got Iovation blackbox', blackbox);
          return blackbox;
        }
        else {
          LoggerProvider.warning(this, LoggerEvent.ProviderException, 'Iovation not available');
        }
      }
      catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Unable to get Iovation blackbox');
      }
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/providers/iovation/iovation.ts